import { type FC } from 'react';
import { Form } from 'formik';
import {
  UiStack,
  UiText,
  UiDrawer,
  UiDrawerOverlay,
  UiDrawerContent,
  UiDrawerBody,
  UiDrawerCloseButton,
  type UiDrawerProps, uiStyles,
} from '@/lib/ui';
import List, { type AppName } from './List';
import { useTenantRoute } from '@/account/hook/useTenantRoute';
import ModuleList from '@/account/dashboard/Modules/Modulelist';

export interface DrawerProps {
  isOpen: UiDrawerProps['isOpen']
  onClose: UiDrawerProps['onClose']
  currentAppName?: AppName
}

const ListDrawer: FC<DrawerProps> = ({
  isOpen,
  onClose,
  currentAppName = undefined,
}) => {
  const { tenant } = useTenantRoute();

  return (
    <UiDrawer
      placement={'left'}
      size={'4xl'}
      isOpen={isOpen}
      onClose={onClose}
    >
      <UiDrawerOverlay />
      <UiDrawerContent
        // borderRightRadius={uiStyles.borderRadius}
      >
        <UiDrawerCloseButton size={'lg'} color={'primary.500'} />
        <UiDrawerBody
          p={0}
          bgColor={'gray.100'}
          // borderRightRadius={uiStyles.borderRadius}
        >
          <UiStack alignItems={'stretch'} p={8}>
            <ModuleList />
          </UiStack>
        </UiDrawerBody>
      </UiDrawerContent>
    </UiDrawer>
  );
};

export default ListDrawer;
